<template>
	    <section id="home-section">
              
      <div class="slider-text">
        <div class="flexslider">
          <ul class="slides">
            <li v-for="(item, index) in data.slides">
              <div class="slider-caption" >
              <h1>{{item.title}}</h1>
               <p>{{item.subtitle}}</p>
                <a :href="'#'+item.button_section+'-section'" class="default-button scroll-btn">{{item.button_title}}</a>
              </div>
            </li>
          </ul>
        </div>
      </div>

    </section>

</template>


<script>
export default {
  name: 'Home',
 props: {
    data: Object
  },
    mounted: function(){
var winDow = $(window);
  // Needed variables
  var $container=$('.iso-call');
  var $filter=$('.filter');

try{
    $container.imagesLoaded( function(){
      $container.trigger('resize');
      $container.isotope({
        filter:'*',
        layoutMode:'masonry',
        animationOptions:{
          duration:750,
          easing:'linear'
        }
      });
      setTimeout(Resize, 1600);
    });
  } catch(err) {
  }

  winDow.on('resize', function(){
    var selector = $filter.find('a.active').attr('data-filter');

    try {
      $container.isotope({ 
        filter  : selector,
        animationOptions: {
          duration: 750,
          easing  : 'linear',
          queue : false,
        }
      });
    } catch(err) {
    }
    return false;
  });
  
  // Isotope Filter 
  $filter.find('a').on('click', function(){
    var selector = $(this).attr('data-filter');

    try {
      $container.isotope({ 
        filter  : selector,
        animationOptions: {
          duration: 750,
          easing  : 'linear',
          queue : false,
        }
      });
    } catch(err) {

    }
    return false;
  });


  var filterItemA = $('.filter li a');

  filterItemA.on('click', function(){
    var $this = $(this);
    if ( !$this.hasClass('active')) {
      filterItemA.removeClass('active');
      $this.addClass('active');
    }
  });

  /*-------------------------------------------------*/
  /* =  Top section
  /*-------------------------------------------------*/

  var windowHeight = winDow.height(),
    topSection = $('#home-section');
  topSection.css('height', windowHeight);

  winDow.on('resize', function(){
    var windowHeight = winDow.height();
    topSection.css('height', windowHeight);
  });


    try {

    var SliderPost = $('.flexslider');

    SliderPost.flexslider({
      animation: "fade"
    });
  } catch(err) {

  }

 
    
  }
}
</script>

<!-- Add "scoped" attribute to limit CSS to this component only -->
<style scoped>

</style>
